import { CustomColumn } from 'components/Table/Table.types';

export const protectCustomColumn = (column: unknown): CustomColumn | undefined => {
  const customColumn = column as CustomColumn;
  if ('className' in customColumn || 'cellTitle' in customColumn) return customColumn;
  return undefined;
};
